module.exports = __webpack_public_path__ + "static/media/video-beliefs-es.dda4f337.vtt";